import ctx from "../../plugins/axios";
 
/**
 * Gets the Product List by Look-Up.
 *
 * @returns {Promise<*>}
 */
const getThpcData = async (obj) => {
  const params = new URLSearchParams({
    search_keyword: obj.search_keyword,
    list_type: obj.list_type,
    clone_type: obj.clone_type,
    department_field: obj.department_field,
  });
 
  return await ctx.get(`/therapeutic?${params.toString()}`);
};
 
export default getThpcData;
 
